import React from "react";
import { Navigate } from "react-router-dom";

// export const PublicGuard = ({ children }) => {
//   const token = localStorage.getItem("User_Token");

//   // If already logged in, redirect away from login/register
//   if (token) {
//     const hasBusiness = localStorage.getItem("selectedBusiness");
//     // console.log("has business - ", hasBusiness);
//     return (
//       <Navigate to={hasBusiness ? "/dashboard" : "/createbusiness"} replace />
//     );
//   }

//   return children;
// };
// export const PublicGuard = ({ children }) => {
//   const token = localStorage.getItem("User_Token");
//   const hasBusiness = localStorage.getItem("selectedBusiness");

//   if (token && hasBusiness) {
//     return <Navigate to="/dashboard" replace />;
//   }

//   return children;
// };
export const PublicGuard = ({ children }) => {
  const token = localStorage.getItem("User_Token");
  const user = localStorage.getItem("Login_User");

  if (token && user) {
    const hasBusiness = localStorage.getItem("selectedBusiness");

    if (hasBusiness) {
      return <Navigate to="/dashboard" replace />;
    } else {
      return <Navigate to="/createbusiness" replace />;
    }
  }

  return children;
};
